module.exports = __webpack_public_path__ + "static/img/551986579_RGB.99d9da9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/551986579_RGB.jpg
// module id = 7V0Z
// module chunks = 0